import React, { useState, useEffect } from "react";
import { Card, Typography } from "antd";
import { SunOutlined, CloudOutlined, ThunderboltOutlined, CloudSyncOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const GreetingCard = () => {
    const [greeting, setGreeting] = useState("");
    const [weather, setWeather] = useState({ temp: 30, cond: "Cerah" });
    const [userName, setUserName] = useState("User");
    const [location, setLocation] = useState("Gudang Pasifik, Jakarta");

    useEffect(() => {
        // 1. Determine Greeting
        const hour = new Date().getHours();
        let greet = "Pagi";
        if (hour >= 11 && hour < 15) greet = "Siang";
        else if (hour >= 15 && hour < 18) greet = "Sore";
        else if (hour >= 18) greet = "Malam";
        setGreeting(greet);

        // 2. Get User Name
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const parsed = JSON.parse(storedUser);
                setUserName(parsed.name || "User");
            } catch (e) {
                setUserName(storedUser);
            }
        }

        // 3. Get User Location & Real Weather
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async (position) => {
                const { latitude, longitude } = position.coords;
                try {
                    // A. Get Address
                    const resLoc = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
                    const dataLoc = await resLoc.json();
                    const city = dataLoc.address.city || dataLoc.address.town || dataLoc.address.village || "Lokasi Anda";
                    setLocation(city);

                    // B. Get Real Weather (Open-Meteo)
                    const resWeather = await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`);
                    const dataWeather = await resWeather.json();
                    const { temperature, weathercode } = dataWeather.current_weather;

                    // Map WMO code to condition string
                    let condition = "Cerah";
                    if (weathercode >= 1 && weathercode <= 3) condition = "Berawan";
                    else if (weathercode >= 45 && weathercode <= 48) condition = "Kabut";
                    else if (weathercode >= 51 && weathercode <= 67) condition = "Hujan";
                    else if (weathercode >= 80 && weathercode <= 99) condition = "Badai";

                    setWeather({ temp: Math.round(temperature), cond: condition });

                } catch (error) {
                    console.error("Weather/Loc Error:", error);
                    setLocation(`${latitude.toFixed(2)}, ${longitude.toFixed(2)}`);
                }
            }, (err) => {
                console.warn("GPS Access Denied:", err);
            });
        } else {
            // Fallback Random
            const conds = ["Cerah", "Berawan", "Mendung"];
            const randCond = conds[Math.floor(Math.random() * conds.length)];
            const randTemp = Math.floor(Math.random() * (34 - 28 + 1)) + 28;
            setWeather({ temp: randTemp, cond: randCond });
        }
    }, []);

    // Weather Icon Helper
    const renderWeatherIcon = (cond) => {
        const style = { fontSize: 48, color: "rgba(255,255,255,0.8)", marginLeft: 16 };
        if (cond === "Cerah") return <SunOutlined style={style} />;
        if (cond === "Berawan" || cond === "Mendung" || cond === "Kabut") return <CloudOutlined style={style} />;
        if (cond === "Hujan") return <CloudSyncOutlined style={style} />;
        if (cond === "Badai") return <ThunderboltOutlined style={style} />;
        return <SunOutlined style={style} />;
    };

    // Dynamic Background Helper
    const getBackgroundGradient = (cond) => {
        if (cond === "Cerah") return "linear-gradient(135deg, #FFD700 0%, #1890ff 100%)"; // Sunny Gold to Blue
        if (cond === "Berawan" || cond === "Mendung") return "linear-gradient(135deg, #bdc3c7 0%, #2c3e50 100%)"; // Gray Cloudy
        if (cond === "Hujan") return "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)"; // Rainy Blue
        if (cond === "Badai") return "linear-gradient(135deg, #232526 0%, #414345 100%)"; // Stormy Dark
        if (cond === "Kabut") return "linear-gradient(135deg, #757F9A 0%, #D7DDE8 100%)"; // Foggy

        // Default (similar to current)
        return "linear-gradient(135deg, #1890ff 0%, #001529 100%)";
    };

    return (
        <Card
            style={{
                marginBottom: 16,
                background: getBackgroundGradient(weather.cond),
                color: "#fff",
                border: "none",
                borderRadius: 8,
                overflow: "hidden",
                position: "relative",
                transition: "background 0.5s ease"
            }}
            bodyStyle={{ padding: "20px 28px" }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative", zIndex: 1 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Title level={3} style={{ color: "#fff", margin: 0, fontWeight: 700, marginBottom: 4 }}>
                        Selamat {greeting}, {userName}
                    </Title>
                    <Text style={{ color: "rgba(255,255,255,0.9)", fontSize: 15 }}>
                        Cuaca di <b>{location}</b> hari ini {weather.temp}°C {weather.cond}.
                    </Text>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ textAlign: "right", marginRight: 8 }}>
                        <Text style={{ color: "#fff", fontSize: 16, fontWeight: 600, display: "block" }}>
                            Jaga Kesehatan - Selamat Bekerja.
                        </Text>
                    </div>
                    {renderWeatherIcon(weather.cond)}
                </div>
            </div>

            {/* Decorative Circle */}
            <div style={{ position: "absolute", right: -20, top: -20, width: 100, height: 100, background: "rgba(255,255,255,0.1)", borderRadius: "50%", zIndex: 0 }} />
        </Card>
    );
};

export default GreetingCard;
